module.exports = __webpack_public_path__ + "img/10.4294707f.png";